import React, { useEffect } from "react";
import LocationMenu from "../Location/LocationMenu";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.refresh();

const Location = () => {
  const windowWidth = window.innerWidth;

  useEffect(() => {
    if (windowWidth >= 1024) {
      gsap.to(".bs-location--content", {
        duration: 3,
        opacity: 1,
        translateX: "25px",
        scrollTrigger: {
          trigger: ".bs-location",
          start: "-=400px"
          // markers: true,
        }
      });
    } else {
      gsap.to(".bs-location--content", {
        duration: 3,
        opacity: 1,
        translateX: "50px",
        scrollTrigger: {
          trigger: ".bs-location",
          start: "-=400px"
          // markers: true,
        }
      });
    }
  }, [windowWidth]);

  return (
    <div id="location" className="bs-location">
      <div className="bs-location--content">
        <h2 className="bs-section--heading large">
          Fresh Beignets Are Just Around The Corner
        </h2>

        <LocationMenu
          label="Find a location"
          position="center"
          location1="https://goo.gl/maps/k84WK4SqxdQfL4ZP7"
          location2="https://maps.app.goo.gl/9rqfP4BaB1U7D2rZ7"
        />
      </div>
    </div>
  );
};

export default Location;
